<template>
  <div
    class="trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md"
  >
    <div
      class="trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between"
    >
      <div class="trezo-card-title">
        <h5 class="mb-0">Tables Of Content</h5>
      </div>
    </div>

    <div class="trezo-card-content">
      <div class="lg:grid lg:grid-cols-3 gap-[25px] items-center">
        <div class="lg:col-span-2">
          <div class="2xl:ltr:pr-[120px] 2xl:rtl:pl-[120px]">
            <div class="toc-accordion" id="tablesOfContentAccordion">
              <div
                class="toc-accordion-item bg-gray-50 dark:bg-[#15203c] rounded-md text-black dark:text-white mb-[10px] last:mb-0"
              >
                <button
                  class="toc-accordion-button open text-base md:text-[15px] py-[19px] px-[20px] md:px-[25px] block w-full ltr:text-left rtl:text-right font-semibold relative"
                  type="button"
                >
                  Introduction to Cybersecurity
                  <i
                    class="ri-arrow-down-s-line absolute top-1/2 -translate-y-1/2 ltr:right-[20px] rtl:left-[20px] md:ltr:right-[25px] md:rtl:left-[25px] text-[20px]"
                  ></i>
                </button>
                <div
                  class="toc-accordion-collapse px-[20px] md:px-[25px] pb-[18px]"
                  style="display: block"
                >
                  <ul>
                    <li
                      class="border-b border-gray-100 sm:flex items-center justify-between py-[12px] md:py-[15px] dark:border-[#1c2846] first:pt-0 last:border-0 last:pb-0"
                    >
                      <a
                        href="javascript:void(0);"
                        class="relative inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-500 ltr:pl-[27px] rtl:pr-[27px]"
                      >
                        <i
                          class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 !text-[20px] -mt-[.5px] text-primary-500 top-1/2 -translate-y-1/2"
                        >
                          info
                        </i>
                        Course Introduction
                      </a>
                      <span
                        class="block text-gray-500 dark:text-gray-400 mt-[10px] sm:mt-0"
                      >
                        2m 24s
                      </span>
                    </li>
                    <li
                      class="border-b border-gray-100 sm:flex items-center justify-between py-[12px] md:py-[15px] dark:border-[#1c2846] first:pt-0 last:border-0 last:pb-0"
                    >
                      <a
                        href="javascript:void(0);"
                        class="relative inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-500 ltr:pl-[27px] rtl:pr-[27px]"
                      >
                        <i
                          class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 !text-[20px] -mt-[.5px] text-primary-500 top-1/2 -translate-y-1/2"
                        >
                          play_circle
                        </i>
                        Cyber Security Introduction
                      </a>
                      <span
                        class="block text-gray-500 dark:text-gray-400 mt-[10px] sm:mt-0"
                      >
                        0m 46s
                      </span>
                    </li>
                    <li
                      class="border-b border-gray-100 sm:flex items-center justify-between py-[12px] md:py-[15px] dark:border-[#1c2846] first:pt-0 last:border-0 last:pb-0"
                    >
                      <a
                        href="javascript:void(0);"
                        class="relative inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-500 ltr:pl-[27px] rtl:pr-[27px]"
                      >
                        <i
                          class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 !text-[20px] -mt-[.5px] text-primary-500 top-1/2 -translate-y-1/2"
                        >
                          list
                        </i>
                        What is Cyber Security and the CIA Triad
                      </a>
                      <span
                        class="block text-gray-500 dark:text-gray-400 mt-[10px] sm:mt-0"
                      >
                        3m 32s
                      </span>
                    </li>
                    <li
                      class="border-b border-gray-100 sm:flex items-center justify-between py-[12px] md:py-[15px] dark:border-[#1c2846] first:pt-0 last:border-0 last:pb-0"
                    >
                      <a
                        href="javascript:void(0);"
                        class="relative inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-500 ltr:pl-[27px] rtl:pr-[27px]"
                      >
                        <i
                          class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 !text-[20px] -mt-[.5px] text-primary-500 top-1/2 -translate-y-1/2"
                        >
                          star
                        </i>
                        Threat Actors: Who are They?
                      </a>
                      <span
                        class="block text-gray-500 dark:text-gray-400 mt-[10px] sm:mt-0"
                      >
                        2m 2s
                      </span>
                    </li>
                    <li
                      class="border-b border-gray-100 sm:flex items-center justify-between py-[12px] md:py-[15px] dark:border-[#1c2846] first:pt-0 last:border-0 last:pb-0"
                    >
                      <a
                        href="javascript:void(0);"
                        class="relative inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-500 ltr:pl-[27px] rtl:pr-[27px]"
                      >
                        <i
                          class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 !text-[20px] -mt-[.5px] text-primary-500 top-1/2 -translate-y-1/2"
                        >
                          hotel_class
                        </i>
                        Types of Threat Actors
                      </a>
                      <span
                        class="block text-gray-500 dark:text-gray-400 mt-[10px] sm:mt-0"
                      >
                        2m 13s
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div
                class="toc-accordion-item bg-gray-50 dark:bg-[#15203c] rounded-md text-black dark:text-white mb-[10px] last:mb-0"
              >
                <button
                  class="toc-accordion-button text-base md:text-[15px] py-[19px] px-[20px] md:px-[25px] block w-full ltr:text-left rtl:text-right font-semibold relative"
                  type="button"
                >
                  Secure Networking
                  <i
                    class="ri-arrow-down-s-line absolute top-1/2 -translate-y-1/2 ltr:right-[20px] rtl:left-[20px] md:ltr:right-[25px] md:rtl:left-[25px] text-[20px]"
                  ></i>
                </button>
                <div
                  class="toc-accordion-collapse px-[20px] md:px-[25px] pb-[18px] hidden"
                >
                  <ul>
                    <li
                      class="border-b border-gray-100 sm:flex items-center justify-between py-[12px] md:py-[15px] dark:border-[#1c2846] first:pt-0 last:border-0 last:pb-0"
                    >
                      <a
                        href="javascript:void(0);"
                        class="relative inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-500 ltr:pl-[27px] rtl:pr-[27px]"
                      >
                        <i
                          class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 !text-[20px] -mt-[.5px] text-primary-500 top-1/2 -translate-y-1/2"
                        >
                          info
                        </i>
                        Network Security Introduction
                      </a>
                      <span
                        class="block text-gray-500 dark:text-gray-400 mt-[10px] sm:mt-0"
                      >
                        2m 24s
                      </span>
                    </li>
                    <li
                      class="border-b border-gray-100 sm:flex items-center justify-between py-[12px] md:py-[15px] dark:border-[#1c2846] first:pt-0 last:border-0 last:pb-0"
                    >
                      <a
                        href="javascript:void(0);"
                        class="relative inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-500 ltr:pl-[27px] rtl:pr-[27px]"
                      >
                        <i
                          class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 !text-[20px] -mt-[.5px] text-primary-500 top-1/2 -translate-y-1/2"
                        >
                          play_circle
                        </i>
                        Introduction to Wired and Wireless Networks
                      </a>
                      <span
                        class="block text-gray-500 dark:text-gray-400 mt-[10px] sm:mt-0"
                      >
                        2m 13s
                      </span>
                    </li>
                    <li
                      class="border-b border-gray-100 sm:flex items-center justify-between py-[12px] md:py-[15px] dark:border-[#1c2846] first:pt-0 last:border-0 last:pb-0"
                    >
                      <a
                        href="javascript:void(0);"
                        class="relative inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-500 ltr:pl-[27px] rtl:pr-[27px]"
                      >
                        <i
                          class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 !text-[20px] -mt-[.5px] text-primary-500 top-1/2 -translate-y-1/2"
                        >
                          list
                        </i>
                        Wired Network Vulnerabilities and How to Protect Wired
                        Networks
                      </a>
                      <span
                        class="block text-gray-500 dark:text-gray-400 mt-[10px] sm:mt-0"
                      >
                        3m 32s
                      </span>
                    </li>
                    <li
                      class="border-b border-gray-100 sm:flex items-center justify-between py-[12px] md:py-[15px] dark:border-[#1c2846] first:pt-0 last:border-0 last:pb-0"
                    >
                      <a
                        href="javascript:void(0);"
                        class="relative inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-500 ltr:pl-[27px] rtl:pr-[27px]"
                      >
                        <i
                          class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 !text-[20px] -mt-[.5px] text-primary-500 top-1/2 -translate-y-1/2"
                        >
                          star
                        </i>
                        Wireless Network Vulnerabilities and How to Protect
                        Wireless Networks
                      </a>
                      <span
                        class="block text-gray-500 dark:text-gray-400 mt-[10px] sm:mt-0"
                      >
                        2m 2s
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div
                class="toc-accordion-item bg-gray-50 dark:bg-[#15203c] rounded-md text-black dark:text-white mb-[10px] last:mb-0"
              >
                <button
                  class="toc-accordion-button text-base md:text-[15px] py-[19px] px-[20px] md:px-[25px] block w-full ltr:text-left rtl:text-right font-semibold relative"
                  type="button"
                >
                  Secure E-Mail
                  <i
                    class="ri-arrow-down-s-line absolute top-1/2 -translate-y-1/2 ltr:right-[20px] rtl:left-[20px] md:ltr:right-[25px] md:rtl:left-[25px] text-[20px]"
                  ></i>
                </button>
                <div
                  class="toc-accordion-collapse px-[20px] md:px-[25px] pb-[18px] hidden"
                >
                  <ul>
                    <li
                      class="border-b border-gray-100 sm:flex items-center justify-between py-[12px] md:py-[15px] dark:border-[#1c2846] first:pt-0 last:border-0 last:pb-0"
                    >
                      <a
                        href="javascript:void(0);"
                        class="relative inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-500 ltr:pl-[27px] rtl:pr-[27px]"
                      >
                        <i
                          class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 !text-[20px] -mt-[.5px] text-primary-500 top-1/2 -translate-y-1/2"
                        >
                          info
                        </i>
                        E-Mail Security Introduction
                      </a>
                      <span
                        class="block text-gray-500 dark:text-gray-400 mt-[10px] sm:mt-0"
                      >
                        2m 24s
                      </span>
                    </li>
                    <li
                      class="border-b border-gray-100 sm:flex items-center justify-between py-[12px] md:py-[15px] dark:border-[#1c2846] first:pt-0 last:border-0 last:pb-0"
                    >
                      <a
                        href="javascript:void(0);"
                        class="relative inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-500 ltr:pl-[27px] rtl:pr-[27px]"
                      >
                        <i
                          class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 !text-[20px] -mt-[.5px] text-primary-500 top-1/2 -translate-y-1/2"
                        >
                          play_circle
                        </i>
                        E-Mail: Overview and Importance
                      </a>
                      <span
                        class="block text-gray-500 dark:text-gray-400 mt-[10px] sm:mt-0"
                      >
                        2m 13s
                      </span>
                    </li>
                    <li
                      class="border-b border-gray-100 sm:flex items-center justify-between py-[12px] md:py-[15px] dark:border-[#1c2846] first:pt-0 last:border-0 last:pb-0"
                    >
                      <a
                        href="javascript:void(0);"
                        class="relative inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-500 ltr:pl-[27px] rtl:pr-[27px]"
                      >
                        <i
                          class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 !text-[20px] -mt-[.5px] text-primary-500 top-1/2 -translate-y-1/2"
                        >
                          list
                        </i>
                        Phishing: Techniques, Implications and How to Spot
                      </a>
                      <span
                        class="block text-gray-500 dark:text-gray-400 mt-[10px] sm:mt-0"
                      >
                        3m 32s
                      </span>
                    </li>
                    <li
                      class="border-b border-gray-100 sm:flex items-center justify-between py-[12px] md:py-[15px] dark:border-[#1c2846] first:pt-0 last:border-0 last:pb-0"
                    >
                      <a
                        href="javascript:void(0);"
                        class="relative inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-500 ltr:pl-[27px] rtl:pr-[27px]"
                      >
                        <i
                          class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 !text-[20px] -mt-[.5px] text-primary-500 top-1/2 -translate-y-1/2"
                        >
                          star
                        </i>
                        Understanding E-Mail Headers for Verification
                      </a>
                      <span
                        class="block text-gray-500 dark:text-gray-400 mt-[10px] sm:mt-0"
                      >
                        2m 2s
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div
                class="toc-accordion-item bg-gray-50 dark:bg-[#15203c] rounded-md text-black dark:text-white mb-[10px] last:mb-0"
              >
                <button
                  class="toc-accordion-button text-base md:text-[15px] py-[19px] px-[20px] md:px-[25px] block w-full ltr:text-left rtl:text-right font-semibold relative"
                  type="button"
                >
                  Secure Internet Browsing
                  <i
                    class="ri-arrow-down-s-line absolute top-1/2 -translate-y-1/2 ltr:right-[20px] rtl:left-[20px] md:ltr:right-[25px] md:rtl:left-[25px] text-[20px]"
                  ></i>
                </button>
                <div
                  class="toc-accordion-collapse px-[20px] md:px-[25px] pb-[18px] hidden"
                >
                  <ul>
                    <li
                      class="border-b border-gray-100 sm:flex items-center justify-between py-[12px] md:py-[15px] dark:border-[#1c2846] first:pt-0 last:border-0 last:pb-0"
                    >
                      <a
                        href="javascript:void(0);"
                        class="relative inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-500 ltr:pl-[27px] rtl:pr-[27px]"
                      >
                        <i
                          class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 !text-[20px] -mt-[.5px] text-primary-500 top-1/2 -translate-y-1/2"
                        >
                          info
                        </i>
                        Internet Security Introduction
                      </a>
                      <span
                        class="block text-gray-500 dark:text-gray-400 mt-[10px] sm:mt-0"
                      >
                        2m 24s
                      </span>
                    </li>
                    <li
                      class="border-b border-gray-100 sm:flex items-center justify-between py-[12px] md:py-[15px] dark:border-[#1c2846] first:pt-0 last:border-0 last:pb-0"
                    >
                      <a
                        href="javascript:void(0);"
                        class="relative inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-500 ltr:pl-[27px] rtl:pr-[27px]"
                      >
                        <i
                          class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 !text-[20px] -mt-[.5px] text-primary-500 top-1/2 -translate-y-1/2"
                        >
                          play_circle
                        </i>
                        Exploring Web-Based Threats
                      </a>
                      <span
                        class="block text-gray-500 dark:text-gray-400 mt-[10px] sm:mt-0"
                      >
                        0m 46s
                      </span>
                    </li>
                    <li
                      class="border-b border-gray-100 sm:flex items-center justify-between py-[12px] md:py-[15px] dark:border-[#1c2846] first:pt-0 last:border-0 last:pb-0"
                    >
                      <a
                        href="javascript:void(0);"
                        class="relative inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-500 ltr:pl-[27px] rtl:pr-[27px]"
                      >
                        <i
                          class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 !text-[20px] -mt-[.5px] text-primary-500 top-1/2 -translate-y-1/2"
                        >
                          list
                        </i>
                        Typo Squatting: Risks and Mitigation
                      </a>
                      <span
                        class="block text-gray-500 dark:text-gray-400 mt-[10px] sm:mt-0"
                      >
                        3m 32s
                      </span>
                    </li>
                    <li
                      class="border-b border-gray-100 sm:flex items-center justify-between py-[12px] md:py-[15px] dark:border-[#1c2846] first:pt-0 last:border-0 last:pb-0"
                    >
                      <a
                        href="javascript:void(0);"
                        class="relative inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-500 ltr:pl-[27px] rtl:pr-[27px]"
                      >
                        <i
                          class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 !text-[20px] -mt-[.5px] text-primary-500 top-1/2 -translate-y-1/2"
                        >
                          star
                        </i>
                        Watering Hole Attacks: Tactics and Countermeasures
                      </a>
                      <span
                        class="block text-gray-500 dark:text-gray-400 mt-[10px] sm:mt-0"
                      >
                        2m 2s
                      </span>
                    </li>
                    <li
                      class="border-b border-gray-100 sm:flex items-center justify-between py-[12px] md:py-[15px] dark:border-[#1c2846] first:pt-0 last:border-0 last:pb-0"
                    >
                      <a
                        href="javascript:void(0);"
                        class="relative inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-500 ltr:pl-[27px] rtl:pr-[27px]"
                      >
                        <i
                          class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 !text-[20px] -mt-[.5px] text-primary-500 top-1/2 -translate-y-1/2"
                        >
                          star
                        </i>
                        Secure Browsing Best Practices
                      </a>
                      <span
                        class="block text-gray-500 dark:text-gray-400 mt-[10px] sm:mt-0"
                      >
                        2m 13s
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div
                class="toc-accordion-item bg-gray-50 dark:bg-[#15203c] rounded-md text-black dark:text-white mb-[10px] last:mb-0"
              >
                <button
                  class="toc-accordion-button text-base md:text-[15px] py-[19px] px-[20px] md:px-[25px] block w-full ltr:text-left rtl:text-right font-semibold relative"
                  type="button"
                >
                  Device Security & Password Management
                  <i
                    class="ri-arrow-down-s-line absolute top-1/2 -translate-y-1/2 ltr:right-[20px] rtl:left-[20px] md:ltr:right-[25px] md:rtl:left-[25px] text-[20px]"
                  ></i>
                </button>
                <div
                  class="toc-accordion-collapse px-[20px] md:px-[25px] pb-[18px] hidden"
                >
                  <ul>
                    <li
                      class="border-b border-gray-100 sm:flex items-center justify-between py-[12px] md:py-[15px] dark:border-[#1c2846] first:pt-0 last:border-0 last:pb-0"
                    >
                      <a
                        href="javascript:void(0);"
                        class="relative inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-500 ltr:pl-[27px] rtl:pr-[27px]"
                      >
                        <i
                          class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 !text-[20px] -mt-[.5px] text-primary-500 top-1/2 -translate-y-1/2"
                        >
                          info
                        </i>
                        Device Security Introduction
                      </a>
                      <span
                        class="block text-gray-500 dark:text-gray-400 mt-[10px] sm:mt-0"
                      >
                        2m 24s
                      </span>
                    </li>
                    <li
                      class="border-b border-gray-100 sm:flex items-center justify-between py-[12px] md:py-[15px] dark:border-[#1c2846] first:pt-0 last:border-0 last:pb-0"
                    >
                      <a
                        href="javascript:void(0);"
                        class="relative inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-500 ltr:pl-[27px] rtl:pr-[27px]"
                      >
                        <i
                          class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 !text-[20px] -mt-[.5px] text-primary-500 top-1/2 -translate-y-1/2"
                        >
                          play_circle
                        </i>
                        Securing Computers, Laptops, and Mobile Devices
                      </a>
                      <span
                        class="block text-gray-500 dark:text-gray-400 mt-[10px] sm:mt-0"
                      >
                        2m 13s
                      </span>
                    </li>
                    <li
                      class="border-b border-gray-100 sm:flex items-center justify-between py-[12px] md:py-[15px] dark:border-[#1c2846] first:pt-0 last:border-0 last:pb-0"
                    >
                      <a
                        href="javascript:void(0);"
                        class="relative inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-500 ltr:pl-[27px] rtl:pr-[27px]"
                      >
                        <i
                          class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 !text-[20px] -mt-[.5px] text-primary-500 top-1/2 -translate-y-1/2"
                        >
                          list
                        </i>
                        Password Best Practices
                      </a>
                      <span
                        class="block text-gray-500 dark:text-gray-400 mt-[10px] sm:mt-0"
                      >
                        3m 32s
                      </span>
                    </li>
                    <li
                      class="border-b border-gray-100 sm:flex items-center justify-between py-[12px] md:py-[15px] dark:border-[#1c2846] first:pt-0 last:border-0 last:pb-0"
                    >
                      <a
                        href="javascript:void(0);"
                        class="relative inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-500 ltr:pl-[27px] rtl:pr-[27px]"
                      >
                        <i
                          class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 !text-[20px] -mt-[.5px] text-primary-500 top-1/2 -translate-y-1/2"
                        >
                          star
                        </i>
                        Multi-Factor Authentication (MFA)
                      </a>
                      <span
                        class="block text-gray-500 dark:text-gray-400 mt-[10px] sm:mt-0"
                      >
                        2m 2s
                      </span>
                    </li>
                    <li
                      class="border-b border-gray-100 sm:flex items-center justify-between py-[12px] md:py-[15px] dark:border-[#1c2846] first:pt-0 last:border-0 last:pb-0"
                    >
                      <a
                        href="javascript:void(0);"
                        class="relative inline-block text-gray-500 dark:text-gray-400 transition-all hover:text-primary-500 ltr:pl-[27px] rtl:pr-[27px]"
                      >
                        <i
                          class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 !text-[20px] -mt-[.5px] text-primary-500 top-1/2 -translate-y-1/2"
                        >
                          star
                        </i>
                        Keeping Devices Up-to-Date
                      </a>
                      <span
                        class="block text-gray-500 dark:text-gray-400 mt-[10px] sm:mt-0"
                      >
                        2m 13s
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="lg:col-span-1">
          <div
            class="bg-primary-500 rounded-md text-center py-[30px] md:py-[50px] px-[20px] md:px-[30px] 2xl:ltr:-ml-[30px] 2xl:rtl:-mr-[30px] 2xl:ltr:mr-[85px] 2xl:rtl:ml-[85px] mt-[20px] md:mt-[25px] lg:mt-0"
          >
            <h4 class="mb-[10px] text-white text-lg md:text-[21px]">
              Unlock Library
            </h4>
            <p class="mb-[20px] text-[#e3eaef]">
              Get access to all videos in the library
            </p>
            <RouterLink
              to="/authentication/sign-up"
              class="inline-block rounded-md font-medium md:text-md py-[11px] md:py-[13px] px-[22px] mb-[15px] text-white bg-[#ffffff14] transition-all hover:bg-white hover:text-black"
            >
              Sign Up - Only $120/mo
            </RouterLink>

            <p class="mb-[20px] text-[#e3eaef]">
              Have an account?
              <RouterLink to="/authentication/sign-in" class="text-white">
                Login
              </RouterLink>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";

export default defineComponent({
  name: "TablesOfContent",
  setup() {
    const initializeAccordions = () => {
      const accordions = document.querySelectorAll<HTMLElement>(
        ".toc-accordion-button"
      );
      accordions.forEach((accordion) => {
        accordion.addEventListener("click", function () {
          const siblingAccordions = Array.from(
            this.closest(
              ".toc-accordion-collapse"
            )?.querySelectorAll<HTMLElement>(".toc-accordion-button") ||
              accordions
          );
          siblingAccordions.forEach((acc) => {
            if (acc !== accordion) {
              acc.classList.remove("open");
              acc.setAttribute("aria-expanded", "false");
              const nextSibling = acc.nextElementSibling as HTMLElement;
              if (nextSibling) nextSibling.style.display = "none";
            }
          });

          this.classList.toggle("open");
          const panel = this.nextElementSibling as HTMLElement;
          if (panel) {
            if (panel.style.display === "block") {
              panel.style.display = "none";
              this.setAttribute("aria-expanded", "false");
            } else {
              panel.style.display = "block";
              this.setAttribute("aria-expanded", "true");
            }
          }
        });
      });
    };

    onMounted(() => {
      initializeAccordions();
    });
  },
});
</script>
